import React, { Component } from "react";
import { Radio, Card } from "antd";
import PatentsChart from "../patent/analytics/charts/field-agg";
import { withRouter } from "react-router";
import PropTypes from "prop-types";

const styles = {
  cardContent: {
    width: "100%",
    padding: "8px 0 0 0",
    textAlign: "center"
  },
  verticalGutter: {
    marginTop: 16
  }
};

const QUERY_MAPPING = {
  number: {
    publication_type: "G",
    publication_status: "Active"
  },
  pvix_sum: {
    publication_type: "G",
    publication_status: "Active"
  },
  annuities: {
    publication_type: "G",
    publication_status: "Active"
  }
};

class StackedBarChart extends Component {
  static propTypes = {
    options: PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.string,
        label: PropTypes.string
      })
    ),
    field: PropTypes.string,
    flag: PropTypes.string,
    extra: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
  };

  state = {
    esIndex: this.props.options[0].value
  };

  render() {
    const { options, field, flag, extra } = this.props;
    const filter = QUERY_MAPPING[this.state.esIndex];
    return (
      <Card title={flag} extra={extra} bodyStyle={styles.cardContent} style={styles.verticalGutter}>
        <Radio.Group value={this.state.esIndex} onChange={e => this.setState({ esIndex: e.target.value })}>
          {options.map((opt, i) => (
            <Radio.Button value={opt.value} key={i}>
              {opt.label}
            </Radio.Button>
          ))}
        </Radio.Group>
        <div style={{ width: "100%", overflow: "auto", }}>
          <PatentsChart
            field={field}
            size={10}
            filter={filter}
            sortBy={this.state.esIndex}
            onSelectBar={v => this._onMergeQueryString(v)}
            exportable={false}
            margin={{ left: 120, right: 16, top: 40, bottom: 16 }}
          />
        </div>
      </Card>
    );
  }

  _onMergeQueryString = qsObj => {
    this.props.router.push({
      pathname: "/patents/search",
      query: {
        ...QUERY_MAPPING[this.state.esIndex],
        ...qsObj
      }
    });
  };
}

export default withRouter(StackedBarChart);
